import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import dayjs from '../../_utils/dayjs.config';
import { Attachment } from '../../_interfaces/Attachment';
import { EditArt } from '../../_interfaces/EditArt';
import { HttpFunctionResult } from '../../_interfaces/HttpFunctionResult';
import { Ticket, TicketBase } from '../../_interfaces/ticket';
import { WorkstepBase } from '../../_interfaces/workstep';
import { WorkstepContent } from '../../_template/ticket-detail/workstep-content/workstep-content.component';
import { HttpService } from '../http.service';
import { AuthService } from '../auth.service';
import { TicketZeit } from '../../_interfaces/TicketTime';
import { Appointment } from '../../_interfaces/appointment';
import { AppointmentItem } from '../../_interfaces/appointmentItems';
import { ContentQuickSearch } from '../../_interfaces/ContentQuickSearch';
import { Task } from '../../_interfaces/Task';
import { Share } from '@capacitor/share';
import clipboard from 'clipboardy';
import { TicketServiceBase } from './ticketBase.service';
import { timeIntervalDifference } from 'src/app/_pipes/timeDifference.Pipe';
import { TicketEditService } from '../ticket-edit.service';
import { StorageManagerService } from '../../_provider/storage-manager.service';
import { environment } from 'src/environments/environment';
import { TaskTemplateItem } from 'src/app/_pages/new-settings/ticket-settings/task-template-overview/task-template-overview.page';
import { DarkmodeService } from '../darkmode.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { GeneralService } from '../general.service';
import { BreadcumbService } from '../breadcumb.service';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { ZeitenService } from '../zeiten.service';
import { ITicketState } from 'src/app/_interfaces/TicketState';
import { FeedbackService } from '../feedback.service';
import { HelperService } from '../helper.service';
import { SocketsService } from '../sockets.service';
import { timer } from 'rxjs';
import { WorkstepContentReadState } from 'src/app/_template/ticket-detail/workstep-content/workstep-read-state-popover/workstep-read-state-popover.component';

export namespace TicketEmployee{
  @Injectable({
    providedIn: 'root'
  })
  export class TicketService extends TicketServiceBase{
  
    private _isLoading: boolean = false

    public activeWorkstep: WorkstepBase

    public runningTimeIdsByWorkstepId: number[] | null = null

    private _prio: EditArt
    private _tasks: Task[] = []
    private _isOnModelDisplayed: boolean = false
    private _appointment: Appointment ={active: false}
    private _totalTimeInSeconds: number = 0
    private _pinnedTicketIds: number[] = []

    constructor(
      public http: HttpService,
      public darkmode: DarkmodeService,
      public authSrv: AuthService,
      private ticketEditSrv: TicketEditService,
      public general: GeneralService,
      private helperSrv: HelperService,
      private storageManager: StorageManagerService,
      private breadcrmbSrv: BreadcumbService,
      private hotkeySrv: HotkeysService,
      private feedbackSrv: FeedbackService,
      public socketSrv: SocketsService
      // private timeSrv: ZeitenService,
      // private timesSrv: ZeitenService
    ) {
      super(http, darkmode, socketSrv, authSrv, general)
          //neues ticket wurde ausgewählt...
      this.general.activeTicket.subscribe(async (ticket:{ticket: TicketBase, workstepId?: number})=>{
        // if(this.workstepContentsOnEdit.some(wc => wc.isMail) && ticket.ticket.id != this.ticket.id){
        //   const deleteMailResponse: boolean = await this.feedbackSrv.confirm("Es sind noch nicht gespeicherte Mails vorhanden. Diese werden beim wechseln des Tickets gelöscht. Fortfahren?", "Mails verwerfen", "Abbrechen")
        //   if(deleteMailResponse) this.workstepContentsOnEdit = this.workstepContentsOnEdit.filter(wc => !wc.isMail)
        //   else return
        // }
        
        if(!ticket?.ticket) return
        this.breadcrmbSrv.breadCrumbAction(null, 0)

        //Variable für Ladeanimation
        this.general.singleTicketLoading = true

        // //Ticket von Server holen wenn ändert...
        this.getSingleTicket(ticket.ticket.id)
        
        // //Breadcrumb setzen
        this.breadcrmbSrv.breadcrumbs.push({
          name: ticket.ticket.description, 
          action: ()=> this.breadcrmbSrv.breadCrumbAction(async ()=> await this.setNewWorkstepAttributes(this.worksteps[this.worksteps.length -1].id, []), 2)
        })

        //Ticket Worksteps holen und anschließend setzen...
        const workstepResult: HttpFunctionResult<WorkstepBase[]> = await this.getWorksteps(ticket.ticket.id)
        if(!workstepResult.success) return 

        //Namen der Arbeitsschritte setzen für anzeigen
        this.ticketEditSrv.setWorksteps(workstepResult.data)

        //Contents des Arbeitsschrittes leeren
        this.clearWorkstepContentList()

        //Wenn workstepid von model übergeben wurde dann dieses als aktives übergeben...
        //sonst das erste aus der list...

        //Muss noch geändert werden dass WorkstepId übergeben werden kann
        const modelWorkstepId: number = 0


        if(modelWorkstepId > 0) this.activeWorkstep = workstepResult.data.find(wb => wb.id == modelWorkstepId)
        else if(ticket.workstepId > 0) this.activeWorkstep  = workstepResult.data.find(wb => wb.id == ticket.workstepId)
        else this.activeWorkstep = workstepResult.data[workstepResult.data.length - 1]

        //Daten des Worksteps zuweisen...
        await this.setNewWorkstepAttributes(this.activeWorkstep.id, [])
        this.setActiveEmployees(this._activeWorkstepId)
        this.setTimes(this._activeWorkstepId)
        
        this.registerTicketSocketEvents(ticket.ticket)

      })
      
      //Subscription setzen die ausgeführt wird wenn neuer Arbeitsschritt ausgewählt wird
      this.setWorkstepSubscription()

    }

    private setWorkstepSubscription(){
      //Ein neuer arbeitschritt wurde gestzt in TicketEmployee.TicketService...
      this.newWorkstepSelected.subscribe(async (workstepId: number)=>{
        if(!workstepId) return

        this.activeWorkstep = this.worksteps.find(w => w.id == workstepId)

        //Breadcrumb setzen wenn Arbeitsschritt eine bezeichnung hat
        if(this.activeWorkstep.description && this.breadcrmbSrv.breadcrumbs.length < 3) this.breadcrmbSrv.addBreadcrumb({
          name: this.activeWorkstep.description,
          action: ()=>this.breadcrmbSrv.breadCrumbAction(()=>{}, 3)
        })

        
        this.contentOffset = 0
        await this.setWorkstepContent(workstepId, "")
        this.setActiveEmployees(workstepId)
        this.setTimes(workstepId)
        this.setAppointment(workstepId)
        this.setTasks(workstepId) 
        this.workstepCanMoreLoad = true
        setTimeout(() => this.general.singleTicketLoading = false,100);
      })
    }
  
    //#region PROPERTIES

    public get isLoading(): boolean{
      return this._isLoading
    }
    
    public set isLoading(val: boolean){
      this._isLoading = val
    }

    public get priority(): EditArt{
      return this._prio
    }

    public set prioriry( art: EditArt){
      this._prio = art
    }
  
    public get tasks(): Task[]{
      return this._tasks
    }
  
    public set tasks(tasks: Task[]){
      this._tasks = tasks
    }

    public set isOnModelDisplayed(val: boolean){
      this._isOnModelDisplayed = val
    }
  
    public get isOnModelDisplayed(): boolean{
      return this._isOnModelDisplayed
    }
  
    public get appointment(): Appointment{
      return this._appointment
    }
  
    public set appointment(val: Appointment){
      this._appointment = val
    }

    public get totalTimeInSeconds(){
      return this._totalTimeInSeconds
    }

    public get totalTimeAsText(){
      const hours: number = this._totalTimeInSeconds / 60 / 60 
      const restSeconds: number = Math.floor((hours % 60) * 60 * 60)
      const hoursString: string = hours > 0 ? `${Math.floor(hours)}:` : "00:"
      return `${hoursString}${ dayjs.utc(Math.floor(restSeconds * 1000)).format("mm:ss")} Std.`
    }

    public get ticketStateDescription(): string{
      const ticketState: ITicketState = this.ticketEditSrv.ticketStates.find(tS=>tS.id == this.ticket.state)
      if(ticketState) return ticketState.description
      if (this.ticket.isClosed) return "Abgeschlossen"
      return "<Status gelöscht>"
  }

    public get timeDifferenceInPercent(){
      const percent: number = 100 / this.targetTime * this._totalTimeInSeconds
      if(percent == Infinity) return 0
      return percent > 100 ? 100.01 : percent
    }

    public get pinnedTicketIds(): number[]{
      return this._pinnedTicketIds
    }

    
    //#endregion
  
    /**
     * Holt eine Liste aller Tickets
     * @returns {Promise<HttpFunctionResult<TicketList>>} Gibt eine Liste aller Tickets zurück des angemeldeten Benutzers
     */
    public async getAllTickets(state: string, filter: string, searchText: string, limit: number, offset: number, sortFilter: string, observerFilter: string): Promise<HttpFunctionResult<TicketBase[]>>{
      return await this.getAPIData<TicketBase[]>(`ticket?state=${state}&filter=${filter}&limit=${limit}&offset=${offset}&searchText=${encodeURIComponent(searchText)}&sorted=false&sortfilter=${sortFilter}&observerfilter=${observerFilter}`)
    }
  
    /**
     * Gibt Informationen des Tickets zurück
     * @param {number} id Id des Tickets
     * @returns {Promise<HttpFunctionResult<Ticket>>}
     */
    public async getSingleTicket(id: number): Promise<HttpFunctionResult<Ticket>>{
      this._isLoading = true
      const result: HttpFunctionResult<Ticket> = await this.getAPIData<Ticket>(`ticket/${id}`)
      if(result.success){
        this._prio = {id: 1, description: result.data?.priority as string}
        this._ticket = result.data as Ticket
        this._ticket.times = []
        this._ticket.activeEmployees = []
        this._ticket.activeEmployeeGroupes = []
      }
      this.isLoading = false
      return result
    }

    /**
     * Holt ein Ticket anhand einer ID
     * @param {number} id id des Tickets
     * @returns 
     */
    public async getSingleTicketValue(id: number): Promise<HttpFunctionResult<Ticket>>{
      return await this.getAPIData<Ticket>(`ticket/${id}`)
    }

    /**
     * Löscht ein Ticket anhand einer ID
     * @param {number} id id des Tickets 
     * @returns 
     */
    public async deleteSingleTicket(id: number): Promise<HttpFunctionResult<any>>{
      return await this.http.DELETE<any>({path: `ticket/${id}`})
    }

    /**
     * pinnt ein angegebenes Ticket an oder entfernt ein
     * @param {number} ticketId id des Tickets welches angepinnt werden soll
     * @param {boolean} toPin legt fest ob es entfernt oder hinzugefügt werden soll
     */
    public async pinTicket(ticketId: number, toPin: boolean){
      if(toPin) this._pinnedTicketIds.push(ticketId)
      else this._pinnedTicketIds.splice(this._pinnedTicketIds.indexOf(ticketId), 1)
      await this.storageManager.setItem<number[]>("PINNED_TICKET_IDS", this._pinnedTicketIds)
    }

    /**
     * Lädt angepinnte Tickets aus dem Storage
     */
    public async loadPinnedTickets(){
      this._pinnedTicketIds = await this.storageManager.getItem<number[]>("PINNED_TICKET_IDS", [])
    }

    /**
     * Gibt alle aktiven Zeit aus der Datenbank
     * @returns 
     */
    public async getAllActiveWorkstepTimes(): Promise<HttpFunctionResult<TicketZeit[]>>{
      return await this.http.GET<TicketZeit[]>({
        path: "ticket/worksteps/activetimes",
        retryOptions: {
          count: 3, 
          delay: (error, retryCount) => timer(retryCount * 1000)
        },
        handleError: false
      })
    }
  
    /**
     * Setzte gestempelte Zeiten eines Arbeitsschrittes
     * @param {number} id Id des Arbeitsschrittes
     * @returns 
     */
    public async setTimes(id: number): Promise<any>{

      const result: HttpFunctionResult<TicketZeit[]> = await this.http.GET<TicketZeit[]>({
        path: `ticket/worksteps/${id}/times`
      })
      if(!result.success) return

      this.ticket.timesGrouped = []
      this.ticket.times = result.data as TicketZeit[]
      this.ticket.times.forEach((ticketTime: TicketZeit)=>{
        let date = this.ticket.timesGrouped.find(d => dayjs(d.datum).format("DD-MM-YYYY") == dayjs(ticketTime.timeFrom).format("DD-MM-YYYY"))
        if(date)date.ticketZeit.unshift(ticketTime)
        else this.ticket.timesGrouped.unshift({
          datum: dayjs(ticketTime.timeFrom).toDate(),
          ticketZeit: [ticketTime],
        })
      })
      this.calculateTotalTime()
      return null

    }

      /**
     * ordnet einen neuen Mitarbeiter zu oder entfernt diesen
     * @param {number} id id des arbeitsschrittes
     */
      public async setActiveEmployees(id: number){

        const result: HttpFunctionResult<any> = await this.http.GET({
          path: `ticket/worksteps/${id}/employees`
        })
        if(!result.success) return

        var employees: number[] = []
        var employeeGroupes: number[] = []
        result.data.forEach((item: {type: string, value: number, isObserver: boolean}) => {
          if(item.isObserver) return
          if(item.type == "employee") employees.push(item.value)
          else if(item.type == "groupe") employeeGroupes.push(item.value)
        })
        this.ticket.activeEmployees = employees
        this.ticket.activeEmployeeGroupes = employeeGroupes
        this.ticket.activeObserverEmployees = result.data.filter((item: {type: string, value: number, isObserver: boolean})=>item.isObserver && item.type == "employee").map((item: {type: string, value: number, isObserver: boolean})=>item.value)
        this.ticket.activeObserverEmployeeGroups = result.data.filter((item: {type: string, value: number, isObserver: boolean})=>item.isObserver && item.type == "groupe").map((item: {type: string, value: number, isObserver: boolean})=>item.value)
      }
  
    //#region [ Main ] test
  
    /**
     * Setzt alle Tätigkeiten des übergebenen Arbeitsschrittes
     * @param {number} id Id des Arbeitsschrittes
     * @returns
     */
    public async setTasks(id: number, setInServive: boolean = true): Promise<Task[]>{
     const result: HttpFunctionResult<Task[]> = await this.getAPIData<Task[]>(`ticket/worksteps/${id}/tasks`)
     if(!result.success) return
     if(setInServive)this.tasks = result.data
     else return result.data
    }
  
    /**
     * Updatet die übergebene Tätigkeit 
     * @param {Task} task Die upzudatende Tätigkeit
     * @returns {HttpFunctionResult<Task>} Neue Werte der Tätigkeit
     */
    public async updateTask(task: Task): Promise<HttpFunctionResult<Task>>{
      return await this.http.PUT<Task, Task>({
        path: "ticket/worksteps/tasks",
        body: task
      })
    }

    /**
     * ordnet die übergebene Tätigkeiten neu
     * @param {Task} task Die upzudatende Tätigkeit
     * @returns {HttpFunctionResult<Task>} Neue Werte der Tätigkeit
     */
    public async reorderTasks(tasks: {key: number, value: number}[]): Promise<HttpFunctionResult<Task>>{
      return await this.http.PUT<{key: number, value: number}[], Task>({
        path: "ticket/worksteps/tasks/reorder",
        body: tasks
      })
    }
  
    /**
     * Löscht eine Übergeben Tätigkeit
     * @param {number} id Id der zu löschenden Tätigkeit
     * @returns 
     */
    public async deleteTask(id: number): Promise<HttpFunctionResult<any>>{
      return await this.http.DELETE<any>({path: `ticket/worksteps/tasks/${id}`})
    }
  
      /**
     * Fügt eine neue Tätigkeit hinzu
     * @param {number} id Id der zu löschenden Tätigkeit
     * @returns 
     */
       public async addTask(task: Task, workstepId?: number): Promise<HttpFunctionResult<Task>>{
        return await this.http.POST<Task, Task>({
          path: `ticket/worksteps/${workstepId ? workstepId : this.activeWorkstepId}/tasks`,
          body: task
        })
      }
  
      /**
       * Gibt alle Inhalte zurück welche der Tätigkeit zugeordnet sind
       * @param {number} taskId Id der Tätigkeit 
       * @returns 
       */
      public async getContentByTask(taskId: number): Promise<HttpFunctionResult<WorkstepContent[]>>{
        return await this.getAPIData<WorkstepContent[]>(`ticket/worksteps/tasks/${taskId}/content`)
      }
  
    //#endregion
  
    /**
     * Holt und setzte den Termin anhand einer workstepId
     * @param {number} id id des Worksteps 
     * @returns 
     */
    public async setAppointment(id: number): Promise<any>{
      const result: HttpFunctionResult<Appointment> = await this.getAPIData<Appointment>(`ticket/worksteps/${id}/appointment`)
  
      if(result.success) {
        if(result.data.active){
          this._appointment = result.data
          this.appointment.timeAsIsoString = dayjs(result.data.time).toISOString()
        }
        else{
          this._appointment = {
            active: false,
            time:  dayjs.utc(new Date()).add(30, "minutes").toDate(),
            timeAsIsoString: dayjs(new Date()).add(30, "minutes").utc(true).toISOString(),
            location: result.data.location
          }
        }
      }
      else this._appointment = { active: false }
      return result
    }
  
    public addTicketTime(ticketTime: TicketZeit): void{
  
      //Benutzer in aktueller Zeit setzen
      const user = this.authSrv.getUser()
      ticketTime.employeeId = user.id
      ticketTime.employeeName = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
  
  
      let date = this._ticket.timesGrouped.find(d => dayjs(d.datum).format("DD-MM-YYYY") == dayjs(ticketTime.date).format("DD-MM-YYYY"))
      if(date)date.ticketZeit.unshift(ticketTime)
      else this._ticket.timesGrouped.unshift({
        datum: ticketTime.date,
        ticketZeit: [ticketTime],
      })
      this._ticket.times.push(ticketTime)
      this.calculateTotalTime()
    }
  

  
    /**
     * Erstellt einen neuen Arbeitsschritt
     * @param {EditArt} art TicketArt, die diesem Arbeitsschritt zugeordnet wird 
     * @returns {Promise<HttpFunctionResult<WorkstepBase>>} erzeugter Arbeitsschritt mit neuer Id
     */
    public async createNewWorkstep(art: EditArt, name: string): Promise<HttpFunctionResult<WorkstepBase>>{
      return new Promise(async resolve=>{
        const workstep = {
          ticketId: this.ticket.id,
          ticketArt: art,
          contactArt: this.kontaktArt,
          workstepName: name
        }

        await this.http.POST<any, WorkstepBase>({
          path: "ticket/workstep",
          body: workstep,
          statusResult: (status: number, result: HttpFunctionResult<WorkstepBase>)=>{
            //Demo
            if(status == 204) return resolve({success: false, data: {id: -31, number: -31}})
            this.worksteps.push(result.data)
            resolve(result)
          }
        })
      })
    }

    /**
     * Gibt alle Personen zurück die den Inhalt gelesen haben
     * @param contentId 
     * @returns 
     */
    public async getWorkstepReadStates(contentId: number){
      return await this.getAPIData<WorkstepContentReadState[]>(`ticket/worksteps/content/${contentId}/readstates`)
    }
  
    /**
     * @param date 
     * @returns 
     */
    public async getAllAppointmentsByDate(date: string, userId: number):Promise<HttpFunctionResult<AppointmentItem[]>>{
      return await this.getAPIData<AppointmentItem[]>(`ticket/appointment/${date}/${+this.authSrv.getUser().id == userId ? "" : userId}`)
    }
  
    /**
     * 
     * @param searchText 
     * @returns 
     */
    public async getAllTicketContentBySearch(searchText: string): Promise<HttpFunctionResult<ContentQuickSearch[]>>{
      return await this.getAPIData<ContentQuickSearch[]>(`ticket/quicksearch/content/${encodeURIComponent(searchText)}`)
    }

    /**
     * Gibt die Tasks für ein Template zurück
     * @param templateId 
     */
    public async getTasksByTemplate(templateId: number): Promise<HttpFunctionResult<TaskTemplateItem[]>>{
      return await this.getAPIData<TaskTemplateItem[]>(`ticket/editinfo/tasktemplates/${templateId}`)
    } 
    
    /**
     * Löscht eine Datei aus Liste
     * @param {Attachment} file Datei die gelöscht werden soll
     * @returns 
     */
    public removeFile(file: Attachment){
      if(!file) return
      this._ticket.attachments.splice(this._ticket.attachments.indexOf(file), 1)
      this._workstepContentWithAttachment.splice(this._workstepContentWithAttachment.findIndex((w => {
        if(w.type == "content") return
        return w.attachment.id == file.id
      })), 1)
    }
  
    /**
     * Fügt neuen Workstep Content hinzu
     * @param {WorkstepContent} content Workstepcontent der hinzugefügt werden soll
     * @returns
     */
    public addEditedWorksteContent(content: WorkstepContent){
      const index: number = this._workstepContent.indexOf(this._workstepContent.find(wc=>wc.id == content.id))
      if(index == null || index == undefined) return
      this._workstepContent[index].htmlText = content.htmlText
      this._workstepContent[index].userText = `${content.from.description} / ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`
    }
  
    /**
     * Öffnet das teilen fenster mit einem TicketLink
     * @param {string} action action die ausgeführt werden soll beim öffnen
     */
    public async shareTicket(action: string = "ShowTicket"){
      await Share.share({
        title: this.ticket.description,
        url: `${this.http.getbaseUrl.replace("/api/", "/")}ticket/${action}/${this.ticket.id}`,
        dialogTitle: this.ticket.description
      })
    }

    /**
     *  Öffnet ein Ticket in einem neuen Tab
     * @param {number} ticketId Id des Tickets
     * @param {number} state Status des Tickets
     * @param {string} description {Bezeichnugndes Tickets}
     */
    public openInNewTab(ticketId: number = null, newTab: boolean = true){

      const url: string = environment.production ? this.http.getbaseUrl.replace("/api/", "") : "http://localhost:8100"
      const urlTicketId: number = ticketId == null ? this.ticket.id : ticketId

      window.open(`${url}/ticket-tab/${urlTicketId}`, newTab ? "_blank" : "_self")
    }

    /**
     * Rechnet alle Zeiten des Arbeitsschrittes zusammen in Sekunden 
     */
    private calculateTotalTime(){
      let seconds: number = 0



      this.ticket.times.forEach(tt=> seconds += dayjs.duration(
        timeIntervalDifference.TranformTime(
        tt,
        [],
        this.ticketEditSrv.ticketArts,
        this.ticketArt?.id || 0
        ) as number, "minutes"
      ).asSeconds())
      this._totalTimeInSeconds = seconds 
    }
  
    /**
     * Kopiert einen Link zum gerade ausgewählten Ticket in die Zwischenablage
     * @param {string} action action die ausgeführt werden soll beim öffnen
     */
    public async copyTicketLinkToClipboard(action: string = "ShowTicket"){
      await this.helperSrv.copyToClipboard(`${this.http.getbaseUrl.replace("/api/", "/")}ticket/${action}/${this.ticket.id}`)
    }
  
    /**
     * Gibt Filter zurück
     * @param {"all" | "open" | "finish" | "wait"} typeText 
     */
    public getTicketFilterType(typeText: "all" | "open" | "finish" | "wait"): EditArt{
      switch (typeText) {
        case "all":
          return {id: 0, typeText: typeText, description: "Alle"}
        case "open":
          return {id: 0, typeText: typeText, description: "Offen"}
        case "finish":
          return {id: 0, typeText: typeText, description: "Fertig"}
        case "wait":
          return {id: 0, typeText: typeText, description: "Warten"}
        default:
          break;
      }
    }
  }



}